import { render, staticRenderFns } from "./AllocatedProjectList.vue?vue&type=template&id=098ae5f8&scoped=true&"
import script from "./AllocatedProjectList.vue?vue&type=script&lang=js&"
export * from "./AllocatedProjectList.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProjectList.vue?vue&type=style&index=0&id=098ae5f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ae5f8",
  null
  
)

export default component.exports